import { FileStatus, Group, DatabaseStatus, DatabaseModel } from './interface/Group'

export const existEmptyFields = (databases: Group[], databaseGroupName: string, databaseModels: DatabaseModel[]): boolean => {
    if (databases.length === 0 || databaseGroupName.trim() === '') {
        return true
    }

    let result = false
    databases.forEach(database => {
        if (
            database?.databaseName.trim() === '' ||
            database.matchFileName.trim() === '' ||
            database.matchTabName.trim() === '' ||
            (databaseHasDateReference(database.databaseName, databaseModels) && database.refDate.trim() === '')
        )
            result = true
    })
    return result
}

export type TabInfo = { [key: string]: number } | undefined
export const resolveTabInfo = (tabInfo: TabInfo, target: 'index' | 'name'): string | number | undefined => {
    if (!tabInfo) {
        return undefined
    }

    switch (target) {
        case 'index': {
            const res = Object.values(tabInfo)
            return res.length ? res[0] : undefined
        }
        case 'name': {
            const res = Object.keys(tabInfo)
            return res.length ? res[0] : undefined
        }
        default:
            return undefined
    }
}

export const parseCheckedFiles = (checkedFiles: FileStatus[]) => {
    return checkedFiles.reduce((result, current) => {
        if (current.databases.length > 0) {
            current.databases.forEach(database => {
                result.push({
                    fileName: current.fileName,
                    database: database.templateName,
                    eventType: database.templateEventType,
                    databaseTab: resolveTabInfo(database.tabInfo as TabInfo, 'name'),
                    sheetIndex: resolveTabInfo(database.tabInfo as TabInfo, 'index'),
                    fileStatus: database.status,
                    message: database.message,
                    uid: current.uid,
                    dateReference: database.templateDateReference
                })
            })
        } else {
            result.push({
                fileName: current.fileName,
                database: 'No matched database',
                databaseTab: '-',
                fileStatus: 'invalid'
            })
        }
        return result
    }, [])
}

export const getFailedUploads = (checkedFiles: FileStatus[]): FileStatus[] => {
    return checkedFiles.filter(fileData => {
        return (
            fileData.statusUploadServer === 'error' ||
            fileData.databases.length === 0 ||
            getFailedDatabaseStatus(fileData.databases).length > 0
        )
    })
}

export const getFailedDatabaseStatus = (databasesStatus: DatabaseStatus[]): DatabaseStatus[] => {
    return databasesStatus.filter(databaseData => {
        return databaseData.status === 'error'
    })
}


export const databaseHasDateReference = (eventType: string, databaseModels: DatabaseModel[]):boolean =>{
    try{
        const databaseModel: DatabaseModel[] = databaseModels.filter(model=>{
            return model.eventType === eventType
        })
        
        return databaseModel[0].dateReference
    }
    catch(error){
        return false
    }
}

export const testDateReference = ( value: string ): boolean =>{
    return /^[0-9]{4}-[0-1][0-9]-[0-3][0-9]/.test(value)
}

export const exitstWrongFormatedDateReference = (groupDatabasesModels : Group[], databaseModels: DatabaseModel[]):boolean =>{
    let output: boolean = false
    groupDatabasesModels.forEach((database)=>{
        if(databaseHasDateReference(database.eventType, databaseModels) && !testDateReference(database.refDate)){
            output = true
        }
    })
    return output
}